import { ReactNode } from 'react';

export enum ActionType {
  showVersionHistory = 'showVersionHistory',
  edit = 'edit',
  changeOnboardingStatus = 'changeOnboardingStatus',
  changeAccountStatus = 'changeAccountStatus',
  delete = 'delete',
  archive = 'archive',
  dearchive = 'dearchive',
  revokeOtpVerification = 'revokeOtpVerification',
  sendInvitationToAccount = 'sendInvitationToAccount',
  linkToBright = 'linkToBright',
  downloadClientQuestionnaire = 'downloadClientQuestionnaire',
}

export type ActionProps = Partial<{
  showEditAction: boolean; // default true
  onChangeOnboardingStatus: () => void;
  onChangeAccountStatus: () => void;
  onDelete: () => void;
  onArchive: () => void;
  onDearchive: () => void;
  onRevokeOtpVerification: () => void;
  onSendInvitationToAccount: () => void;
  onLinkToBright: () => void;
  onDownloadClientQuestionnaire: () => void;
}>;

export interface ClientFormContentProps {
  content: ReactNode;
  shownTabBar: boolean;
  headerTitle: string;
  submitLoading?: boolean;
  actionMenuProps?: ActionProps;
  topContent?: ReactNode;
  headerAfterContent?: ReactNode;
  headerRightContent?: ReactNode;
  onEnableReadOnly: () => void;
  resetForm: () => void;
  onEdit: () => void;
  onShowVersionHistory?: () => void;
}
